(() => {
  const init = () => document.querySelectorAll('[data-furlab-footer]').forEach(root => {
    if (root.dataset.ready) return;
    root.dataset.ready = 'true';
    const menus = [...root.querySelectorAll('details')];
    const mobile = window.matchMedia('(max-width: 767px)');
    const sync = () => menus.forEach(menu => { menu.open = !mobile.matches; });
    sync();
    mobile.addEventListener('change', sync);
    menus.forEach(menu => menu.addEventListener('toggle', () => {
      if (mobile.matches && menu.open) menus.forEach(other => { if (other !== menu) other.open = false; });
    }));
  });
  init();
  document.addEventListener('shopify:section:load', init);
})();
